<template>
	<div>
		<sub-header bizCd="05"/>
		<div class="sub_visual sub06">
			<div class="container">
				<div class="sub_txt">
					<div class="tit">콘텐츠·멤버십 제휴 </div>
					<div class="comment">시너지를 극대화하는 에듀윌의 우수 콘텐츠와 파트너십으로 <br>
						함께 성장하세요.</div>
				</div>
			</div>
		</div>
		<div class="contents aos-all">
			<div class="container">
				<div class="sec">
					<div class="sub_tit">콘텐츠 제휴</div>
					<div class="con">
						<div class="txt">에듀윌의 다양한 콘텐츠를 더 다양한 플랫폼에서 제공할 수 있습니다.</div>
						<div class="partnership_wrap">
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership01.png" alt="콘텐츠제휴"/></div>
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership02.png" alt="콘텐츠제휴"/></div>
						</div>
					</div>
				</div>
				<div class="sec">
					<div class="sub_tit">멤버십 제휴</div>
					<div class="con">
						<div class="txt line02">멤버십과 연계한 에듀윌과의 파트너십으로 <br>귀사의 고객분들께 특별한 혜택과 만족스런 경험을 제공할 수 있습니다.</div>
						<div class="partnership_wrap">
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership03.png" alt="멤버십제휴"/></div>
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership04.png" alt="멤버십제휴"/></div>
						</div>
					</div>
				</div>
				<div class="sec">
					<div class="sub_tit">결합상품 제휴</div>
					<div class="con">
						<div class="txt line02">컨버전스 시대, <br>에듀윌 콘텐츠와의 결합으로 새롭게 가치를 창출하고 시장을 선도하세요.</div>
						<div class="partnership_wrap">
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership05.png" alt="결합상품제휴"/></div>
							<div class="pa_img"><img src="//img.eduwill.net/resources/b2b/dev/images/partnership06.png" alt="결합상품제휴"/></div>
						</div>
					</div>
				</div>
				<div class="sec">
					<div class="clearfix">
						<div class="sub_tit"><p class="mx200">콘텐츠 제휴 Flow</p></div>
					</div>
					<div class="con_wide">
						
						<!-- flow PC -->
						<div class="flow_common flow_m_hidden">
							<div class="top_wrap">
								<div class="text">콘텐츠, 서비스 제공, 고객지원</div>
								<div class="flow_bg"></div>
							</div>
							<div class="f_wrap">
								<div class="step01 aos-item" data-aos="fade-right" data-aos-delay="300" data-aos-offset="0"><img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-01.png" alt="고객사"/></div>
								<div class="step02 flow_line aos-item" data-aos="fade-right" data-aos-delay="450" data-aos-offset="0">
									<div class="text ex"><span>콘텐츠 제휴 문의, 제휴 서비스 협의</span></div>
									<div class="arrow_right"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
									<div class="arrrow_left"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
									<div class="text">교육 콘텐츠 제공, 결합</div>
								</div>
								<div class="step03 aos-item" data-aos="fade-right" data-aos-delay="600" data-aos-offset="0">
									<div class="step_edu">
										<div class="step_edu_con">
											<img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png"/>
											<p>에듀윌</p>
										</div>
									</div>
								</div>
								<div class="step04 flow_line aos-item" data-aos="fade-right" data-aos-delay="750" data-aos-offset="0">
									<div class="text">고객지원</div>
									<div class="arrow_right"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
									<div class="arrrow_left"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
									<div class="text">학습 문의</div>
								</div>
								<div class="step05 aos-item" data-aos="fade-right" data-aos-delay="900" data-aos-offset="0"><img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-03-02-03.png" alt="고객"/></div>
							</div>
							<div class="bottom_wrap">
								<div class="flow_bg"></div>
								<div class="text">관련문의</div>
							</div>
						</div>
						
						
						<!-- flow Mobile  -->
						<div class="flow_common flow_pc_hidden">
							<div class="f_wrap">
								<div class="wide">
									<div class="step_edu aos-item" data-aos="fade-right" data-aos-delay="450" data-aos-offset="0">
										<div class="step_edu_con">
											<img src="//img.eduwill.net/resources/b2b/dev/images/logo_on.png"/>
											<p>에듀윌</p>
										</div>
									</div>
								</div>
								<div class="stepper">
									<div class="step_left aos-item" data-aos="fade-right" data-aos-delay="300" data-aos-offset="0">
										<div class="flow_line">
											<div class="text s01">콘텐츠 제휴 문의, 제휴 서비스 협의</div>
											<div class="arrow_right s02"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-2.png" alt="flow화살표"/></div>
											<div class="arrow_left s03"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
											<div class="text s04">교육 콘텐츠 제공, 결합</div>
										</div>
										<div class="step_default">
											<img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-01.png" alt="고객사"/>
										</div>
									</div>
									<div class="step_right aos-item" data-aos="fade-right" data-aos-delay="600" data-aos-offset="0">
										<div class="flow_line">
											<div class="text s05">고객지원</div>
											<div class="arrow_right s06"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
											<div class="arrow_left s07"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
											<div class="text s08">관련<br>문의</div>
										</div>
										<div class="step_default">
											<img src="//img.eduwill.net/resources/b2b/dev/images/img-flow-02-01-03.png" alt="수강생"/>
										</div>
									</div>
									<div class="step_center aos-item" data-aos="fade-right" data-aos-delay="600" data-aos-offset="0">
										<div class="flow_line">
											<div class="text s05">콘텐츠, 서비스 제공 고객지원</div>
											<div class="arrow_right s09"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5.png" alt="flow화살표"/></div>
											<div class="arrow_left s10"><img src="//img.eduwill.net/resources/b2b/dev/images/path-5-copy.png" alt="flow화살표"/></div>
											<div class="text s11">관련문의</div>
										</div>
									</div>
								</div>
							</div>
						</div>
		
					</div>
				</div>
			</div>
			<div class="sub_partner">
				<div class="container">
					<div class="title_line">
						<div class="pa_tit">Partner</div>
						<div class="text">에듀윌과 함께하는 콘텐츠·멤버십 제휴 파트너사입니다.</div>
					</div>
					<ul class="pa_slider_scroll">
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-39.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-45.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-41.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-42.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-43.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-44.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-53.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-57-1.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-46.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-47.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-15.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-48.png" /></li>
						<li><img src="//img.eduwill.net/resources/b2b/dev/images/partner/ci-49.png" /></li>
					</ul>
				</div>
			</div>
		</div>
			<div class="float_counsel m_hidden">
        <div class="group-wrap">
            <div class="group">
                <div class="text">에듀윌과 함께<br>변화를 시작하세요.</div>
                <div class="button" @click="showCounsel('01')"><a href="javascript:;" @click="show_counsel('01')">맞춤상담신청</a></div>
                <div class="ico-hand"></div>
            </div>
        </div>
    </div>
    <div class="float_counsel_mobile pc_hidden">
		<a class="circle_counsel" @click="showCounsel('01')">맞춤<br>상담</a>
    </div>
	</div>
</template>

<script>
import SubHeader from "@/layouts/SubHeader";
import eventBus from "@/eventBus/event-bus";

export default {
	name: "mainCpEdu",
	components: {SubHeader},
	data() {
		return {}
	},
	
	computed: {
	},
	
	methods: {
		showCounsel(v) {
			eventBus.$emit("show-counsel", v);
		},
		closeCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup().close();
		},
		showCurriculum(v) {
			$('.curriculum_pop_' + v).bPopup();
		}
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
}
</script>

<style scoped>

</style>
